import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import ReactGA from "react-ga";

import "react-toastify/dist/ReactToastify.css";
import "./root.less";

import ConfirmationPopup from "@ui/confirmation_popup";

import Discovery from "./mdboot/discovery";
import MantaLegacyPageRedirect from "./mdboot/manta_legacy_page_redirect";
import Users from "./mdboot/users";
import TrialBanner from "../containers/trial_banner/trial_banner";

export default class Root extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    fetchPublicSessionHash: PropTypes.func.isRequired,
    fetchSession: PropTypes.func.isRequired,
    isDemystUser: PropTypes.oneOf(["true", "false"]),
    isFetched: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.oneOf(["true", "false"]),
    sessionHash: PropTypes.string,
    userId: PropTypes.string
  };

  state = {
    shouldShowConfirmation: null
  };

  componentDidMount() {
    const {
      fetchPublicSessionHash,
      fetchSession
    } = this.props;

    fetchPublicSessionHash();
    fetchSession();
  }

  componentDidUpdate(prevProps) {
    const {
      currentUser, isDemystUser, isLoggedIn, sessionHash, userId
    } = this.props;

    if (sessionHash && sessionHash !== prevProps.sessionHash) {
      ReactGA.set({
        dimension5: sessionHash
      });
    }
    if (currentUser && currentUser !== prevProps.currentUser) {
      // Once we have current user, we have all the following props:
      ReactGA.set({
        dimension2: isLoggedIn,
        dimension3: userId,
        dimension4: isDemystUser
      });
    }
  }

  get locationAfterLogin() {
    // the logic here is duplicated in the sessions_controller
    // because we don't have just one thing that controls where the user
    // is sent after logging in.
    const { currentUser } = this.props;

    if (currentUser.needs_to_change_password) {
      return "/users/password_expired";
    }

    if (currentUser.tos_outdated) {
      return "/tos_agree";
    }

    if (currentUser.destination_url) {
      return currentUser.destination_url;
    }

    return "/discovery";
  }

  getUserConfirmation = (pathname, callback) => {
    this.setState({
      shouldShowConfirmation: true,
      navigationCallback: callback
    });
  };

  renderLeaveConfirmation() {
    const { navigationCallback, shouldShowConfirmation } = this.state;

    if (!shouldShowConfirmation) {
      // Listen for a need of showing a confirmation message
      return null;
    }

    const closeAndRespond = (response) => {
      this.setState({
        shouldShowConfirmation: false,
        navigationCallback: null
      });
      navigationCallback(response);
    };

    const onCancel = () => closeAndRespond(false);
    const onConfirm = () => closeAndRespond(true);

    return (
      <ConfirmationPopup
        title="Unsaved Changes"
        onConfirm={onConfirm}
        onCancel={onCancel}
        cancelButtonLabel="Stay on Page"
        confirmButtonLabel="Leave Page"
        isOpen={shouldShowConfirmation}
      >
        <p>Leave without saving updates?</p>
        <p>Your changes will not be saved if you leave without clicking on "Save Updates" on this page.</p>
      </ConfirmationPopup>
    );
  }

  render() {
    const { currentUser, isFetched } = this.props;

    if (!isFetched) {
      // Until session data is not fetched, don't render any page and don't redirect the user anywhere
      return <div className="preloader-wrapper" />;
    }

    const isLoggedIn = Boolean(currentUser);

    if (isLoggedIn && currentUser.destination_url) {
      // console.log("In this bad boy, got destination_url", currentUser.destination_url);
      window.location = currentUser.destination_url;
      return null;
    }

    return (
      <div className="Root">
        <ToastContainer
          hideProgressBar
          newestOnTop
          transition={Slide}
        />
        {this.renderLeaveConfirmation()}
        <TrialBanner />
        <Router getUserConfirmation={this.getUserConfirmation}>
          <Switch>
            {isLoggedIn && <Route path="/discovery" component={Discovery} />}
            {isLoggedIn && <Route path="/tos_agree" component={MantaLegacyPageRedirect} />}
            <Route path="/users" component={Users} />
            <Redirect to={isLoggedIn ? this.locationAfterLogin : "/users/sign_in"} />
          </Switch>
        </Router>
      </div>
    );
  }
}
